import { lazy } from 'react';
import { retry } from '../../config/utils';

const ForgotPassword = lazy(() => retry(()=> import(/* webpackChunkName: "forgot-password" */ "./index")));

export default ForgotPassword;